import React, { useEffect, useState } from "react";
import { FaXmark } from "react-icons/fa6";
import { IoMdArrowDropdown } from "react-icons/io";
import { useDispatch } from "react-redux";
import { updateLevel2Properties } from "../../../WorkbookSlice";
import { v4 as uuidv4 } from "uuid";

export default function GotoSheetActionModal({
  CloseSecondModal,
  handleSecondModalClose,
  sheetsArray,
  sourceSheetObject,
  targetSheetArray,
  properties,
  tabledata,
}) {
  // console.log(properties);
  const dispatch = useDispatch();
  const [actionName, setActionName] = useState(
    properties !== null ? properties.name : "Go to sheet"
  );
  // // console.log(actionName);
  const [sourceSheet, setSourceSheet] = useState(
    properties !== null ? properties.sourceSheet : sourceSheetObject
  );
  // // console.log(sourceSheet);
  const [targetSheets, setTargetSheets] = useState(
    properties !== null && properties !== undefined
      ? properties.targetSheets
      : []
  ); // Changed to array
  // console.log(targetSheets);
  const [selectedOption, setSelectedOption] = useState("onClick");
  // console.log(selectedOption);

  const [error, setError] = useState(null);
  // // console.log(error);

  useEffect(() => {
    if (!actionName) {
      setError("Name is empty");
    } else if (!sourceSheet) {
      setError("Please select a source sheet");
    } else if (targetSheets.length === 0) {
      setError("Please select at least one target sheet");
    } else {
      setError(null);
    }
  }, [actionName, sourceSheet, targetSheets]);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleNameChange = (e) => {
    setActionName(e.target.value);
  };

  const handleSourceSheet = (event, sheetName, sheetid) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setSourceSheet({ SheetName: sheetName, Sheetid: sheetid });
    } else {
      setSourceSheet(null);
    }
  };

  const handleTargetSheet = (event, sheetName, sheetid) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setTargetSheets([{ SheetName: sheetName, Sheetid: sheetid }]);
    } else {
      setTargetSheets([]);
    }
  };

  const handleOk = () => {
    let actionObject;
    if (actionName !== "" && sourceSheet !== null && targetSheets.length) {
      actionObject = {
        uuid: uuidv4(),
        action: "GoToSheet",
        name: actionName,
        sourceSheet: sourceSheet,
        targetSheets: targetSheets,
        filterType: "temporary",
        reduxKey: selectedOption,
      };
    }
    const Sheetid = sourceSheet ? sourceSheet.Sheetid : null;
    if (Sheetid) {
      const isSelectedEventAlreadyInUse = tabledata.find(
        (actionItem) => actionItem.reduxKey === actionObject.reduxKey
      );
      // console.log(isSelectedEventAlreadyInUse);

      if (isSelectedEventAlreadyInUse) {
        // console.log("this event is already is use");
      } else {
        // console.log("create an action");
        dispatch(
          updateLevel2Properties({
            reduxKey: selectedOption,
            Sheetid: Sheetid,
            parentKey: "actions",
            value: actionObject,
            itemInArray: false,
            index: null,
          })
        );
      }
    } else {
      console.error("source sheet is null");
    }
    handleSecondModalClose();
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleOk(); // Call your function here
    }
  }

  return (
    <main className="fixed inset-0 bg-opacity-50 flex flex-col items-center justify-center z-20"  onKeyDown={handleKeyDown}>
      <main className="w-[40rem] h-auto bg-white shadow-2xl rounded-lg">
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg">
          <span className="text-lg font-medium">Add Go To Sheet Action</span>
          <button
            onClick={CloseSecondModal}
            className="text-gray-500 hover:text-black"
          >
            <FaXmark />
          </button>
        </header>
        <section className="p-4 w-full flex flex-col gap-2 items-start justify-start">
          <div className="w-full flex flex-col gap-2 items-start justify-start">
            <label htmlFor="Name">Name</label>
            <input
              type="text"
              name="name"
              id="name"
              value={actionName}
              onChange={handleNameChange}
              className="w-full px-2 border"
            />
          </div>

          <div className="flex items-center justify-between gap-2 w-full h-[10rem]">
            {/* Source Sheet */}
            <div className="w-[50%] flex flex-col items-start justify-start gap-[2px] h-full">
              <button className="w-full flex items-center justify-between gap-1 border p-[2px]">
                Source Sheet <IoMdArrowDropdown />
              </button>

              <div className="border w-full p-[2px] h-32 overflow-hidden overflow-y-auto">
                {sheetsArray
                  .filter((item) => item.sheetType !== "dashboard")
                  .map((item, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          handleSourceSheet(e, item.SheetName, item.ID)
                        }
                        checked={sourceSheet?.Sheetid === item.ID}
                        className="checkbox-input"
                      />
                      <label>{item.SheetName}</label>
                    </div>
                  ))}
              </div>
            </div>

            <div className="w-[50%] flex flex-col items-start h-full">
              <h1 className="font-medium text-gray-700">Run On Action</h1>
              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  value="onClick"
                  checked={selectedOption === "onClick"}
                  onChange={handleOptionChange}
                  className="mr-2"
                />
                <span className="font-light">Click</span>
              </label>

              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  value="onDoubleClick"
                  checked={selectedOption === "onDoubleClick"}
                  onChange={handleOptionChange}
                  className="mr-2 "
                />
                <span className="font-light">Double Click</span>
              </label>
            </div>
          </div>

          {/* Target Sheet */}
          <div className="w-full flex flex-col items-start justify-start gap-[2px]">
            <button className="w-full flex items-center justify-between gap-1 border p-[2px]">
              Target Sheet <IoMdArrowDropdown />
            </button>

            <div className="border w-full p-[2px] h-32 overflow-hidden overflow-y-auto">
              {sheetsArray
                .filter((item) => item.sheetType !== "dashboard")
                .map((item, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      onChange={(e) =>
                        handleTargetSheet(e, item.SheetName, item.ID)
                      }
                      checked={targetSheets.some(
                        (sheet) => sheet.Sheetid === item.ID
                      )}
                      className="checkbox-input"
                    />
                    <label>{item.SheetName}</label>
                  </div>
                ))}
            </div>
          </div>
        </section>
        <footer className="w-full flex items-center justify-end gap-4 p-3 bg-gray-50 rounded-b-lg">
          {error !== null && (
            <p className="text-red-700 font-medium">{error}</p>
          )}
          <button className="border w-20" onClick={CloseSecondModal}>
            Cancel
          </button>
          <button
            className={`border w-20 ${
              error !== null
                ? "bg-gray-400 text-black"
                : "bg-blue-950 text-white"
            } `}
            disabled={error !== null}
            onClick={handleOk}
          >
            Ok
          </button>
        </footer>
      </main>
    </main>
  );
}
